import { For, Match, Show, Switch, createEffect, createMemo, createSignal, untrack } from "solid-js";
import type { MainProps } from "./_model";
import { solidstate } from ":setup/qstate";
import { account } from "./apis";
import { Loader2 } from ":src/components/loaders";
import { DetailsForm, PasswordForm } from "./components";

export default function Profile(props: MainProps) {
  const $details = solidstate.createAsync(account.get);
  const $meta = createMemo(() => {
    if (!$details.state.success) {
      return null;
    }
    const details = $details.value;
    return {
      id: details?.reference2 ?? "UNKNOWN REFERENCE",
    };
  });

  return (
    <section class="w-full flex-col h-full px-3 py-4 overflow-x-hidden  !overflow-y-auto md:(px-5 py-3)">
      <h1 class="flex flex-col  text-1.1rem whitespace-nowrap capitalize space-y-2 mb-2 <md:text-1rem">
        <p>Profile Setting</p>
        {$meta() != undefined && (
          <span class="before:(content-['ID:_'] text-text-alt) text-brand text-0.6em <md:(text-0.5em)">
            {"#"}
            {$meta().id}
          </span>
        )}
      </h1>
      <Switch>
        <Match when={$details.state.loading}>
          <Loader2 msg="Loading Details..." />
        </Match>
        <Match when={$details.state.failed}>an error occurred while fetching {$details.error}</Match>
        <Match when={$details.state.success}>
          <DetailsForm details={$details.value} />
          <PasswordForm details={$details.value} />
        </Match>
      </Switch>
    </section>
  );
}
